/* 🤖 this file was generated by svg-to-ts */
export const matIconSpellcheck: {
  name: 'spellcheck';
  data: string;
} = {
  name: 'spellcheck',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z"/></svg>`
};
